module.exports = __webpack_public_path__ + "img/Logo_Lederhoseland_2024.5f9f9ef3.png";